import * as React from 'react';
import Nav from './Nav';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';

function Layout({ children }) {

  // Layout es un componente presentacional que solo renderiza Nav + children
  // Nav se encargará de obtener userData desde el contexto
  //
  // Nota: el espacio reservado para el riel de íconos del menú NO se maneja
  // acá (ver Nav.js / SidebarMenu.js) porque la gran mayoría de las páginas
  // usan `<Layout/>` autocerrado con su contenido como hermano, fuera de
  // `children` — cualquier padding puesto acá no les llegaría.
  return (
    <>
      <div className="print:hidden">
        <Nav showButton={true} />
        <React.Fragment>
          <CssBaseline />
          <Container maxWidth="xl">
            {children}
          </Container>
        </React.Fragment>
      </div>
    </>
  );
}

// ✅ Memoizar Layout para evitar re-renders si children no cambió
export default React.memo(Layout);
